module.exports = __webpack_public_path__ + "img/DDBU-TV-LOGO.2192b07c.png";